import { useNavigate } from "react-router-dom";
import { Grid, Typography, TextField, Button } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";  //FB 8962
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import UseStyle from "../../../css/styles";
//FB 8962
import { useState, useEffect } from "react";//FB 7469
import { VerifyPatientDemographics } from "../../../api";
//FB 7528
import useMediaQuery from "@mui/material/useMediaQuery";


// Update log
// FB  6192   02/06/2023  DK  Added page to handle Forgot password
// FB  7045   07/19/2023  KK  PP- Unable to enter Date fields manually
// FB  7085   07/27/2023  GS  Email can be used as username
// FB  7239   08/17/2023  KK  PP- DOB when entered manually is not taken into account
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7528   10/05/2023  DK  Issue with DOB field (Picking a day earlier)
// FB  7565   10/11/2023  SK  Rename the Placeholder for Username field in Login and Forgot Password Screen
// FB  8962   06/27/2024  DK  DOB is changing automatically

export default function ForgotPassword() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  var JSAlert = require("js-alert");
  const styles = UseStyle();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });
  //FB 8962
  const [fields, setFields] = useState({ Login: "", PatientEmail: "", PatientDOB: "" });
  const [dob, setDOB] = useState(null as unknown as Date);
  const [errors, setErrors] = useState<any>({});
  const handleDateChange = async (date: any) => {
    if (date != null && date != "Invalid Date") {
      //FB 7528
      handleInputChange(date); // FB 7239 KK
    }
  };
  const handleInputChange = (e: any) => {
    if (!isNaN(Date.parse(e))) {
      setDOB(e);    //FB 8962
      setErrors({ PatientDOB: false });
      //FB 8962
      setFields({
        ...fields,
        PatientDOB: formatDate(e.getDate().toString(), (e.getMonth() + 1).toString(), e.getFullYear().toString())
      });
    } else {
      setErrors({ [e.target.name]: false });
      setFields({
        ...fields,
        [e.target.name]: e.target.value,
      });
    }
  };

  //FB 8962
  function formatDate(date: string, month: string, year: string) {
    var month = month.length == 1 ? "0" + month : month;
    var date = date.length == 1 ? "0" + date : date;
    var formattedDate = year + "-" + month + "-" + date;
    return formattedDate;
  }

  function Validate() {
    if (fields.Login == undefined || fields.Login === "") {
      setErrors((errors: any) => ({ ...errors, Login: true }));
      return false;
    }
    if (fields.PatientDOB == undefined || fields.PatientDOB.toString() == "") {
      setErrors((errors: any) => ({ ...errors, PatientDOB: true }));
      return false;
    }
    if (fields.PatientEmail == undefined || fields.PatientEmail === "") {
      setErrors((errors: any) => ({ ...errors, PatientEmail: true }));
      return false;
    } else {
      if (!/\S+@\S+\.\S+/.test(fields.PatientEmail)) {
        JSAlert.alert(
          "Please enter a valid email id",
          null,
          JSAlert.Icons.Failed
        );
        setErrors((errors: any) => ({ ...errors, PatientEmail: true }));
        return false;
      }
    }
    return true;
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (Validate()) {
      const result = await VerifyPatientDemographics(fields);
      if (result.alertType == "Failed") {
        JSAlert.alert(result.message, null, JSAlert.Icons.Failed);
      } else {
        sessionStorage.setItem("PatientContact", JSON.stringify(result));
        navigate("/user/forgotpassword/verification");
      }
    }
  };

  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End

  return (
    <form onSubmit={handleSubmit}>
      {/* FB 7469 - Maintained structure for code after form tag and Doctor Direct Text Changed to License Name - Begin */}
      <Grid container spacing={1} flexDirection="column">
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: "#F5F5F5",
            minHeight: "75px",
            alignItems: "center",
            display: "flex",
            paddingLeft: matches == false ? "20px" : "90px",
          }}
        >
          <Typography variant="h5" style={{ backgroundColor: "#F5F5F5" }}>
            <b>Recover your {HeaderText} Password</b>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            marginTop: "15px",
          }}
        >
          <Typography variant="h6">
            <b>Verification</b>
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            marginTop: "15px",
          }}
        >
          <Typography variant="body1">
            Please verify personal information to recover your password
          </Typography>
          <hr />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="Login"
            name="Login"
            label="Username" //FB 7110  //FB 7565
            value={fields.Login}
            onChange={handleInputChange}
            error={errors.Login}
            variant="outlined"
            required
            fullWidth
          />
        </Grid>

        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          {/* FB 7045 KK Begin */}
          {/* FB 8962 */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                InputLabelProps={{ shrink: true }}
                className={styles.datepickerroot}
                id="PatientDOB"
                name="PatientDOB"
                label="Date of Birth"
                value={dob}
                format="MM/dd/yyyy"
                placeholder="MM/dd/yyyy"
                openTo="year"
                views={["year", "month", "date"]}
                onChange={(date) => handleDateChange(date)}
                inputVariant="standard"
                orientation="portrait"
                disableFuture
                required
                fullWidth
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
          {/* FB 7045 KK End */}
        </Grid>
        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="PatientEmail"
            name="PatientEmail"
            label="Email"
            value={fields.PatientEmail}
            onChange={handleInputChange}
            error={errors.PatientEmail}
            variant="outlined"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          {" "}
          <Button
            type="submit"
            variant="contained"
            className={styles.navigationButton}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "20px",
              marginBottom: "60px",
            }}
          //onClick={handleSubmit}
          //style={{ display: isTimeOut ? "flex" : "none", marginLeft: 5 }}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      {/* FB 7469 - End */}
    </form>
  );
}
